import { useQuery } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import { useApi } from "@/core/api";
import type { PayPlanResponse } from "./types";

export const payPlanPath = (businessId: string, runId: string) =>
  `/businesses/${businessId}/ai_script_runs/${runId}/pay_plan`;

export const payPlanKey = (businessId: string | null, runId: string | null) =>
  ["pay-plan", businessId, runId] as const;

export const payPlanQueryOptions = (
  api: AxiosInstance,
  businessId: string | null,
  runId: string | null,
) => ({
  queryKey: payPlanKey(businessId, runId),
  queryFn: async (): Promise<PayPlanResponse> => {
    if (!businessId || !runId) throw new Error("Run is required");

    return api
      .get<PayPlanResponse>(payPlanPath(businessId, runId))
      .then((response) => response.data);
  },
  enabled: !!businessId && !!runId,
  retry: false,
  // A published run's script version is immutable, so its plan document is too.
  staleTime: Infinity,
});

export const usePayPlan = (businessId: string | null, runId: string | null) => {
  const api = useApi();

  return useQuery(payPlanQueryOptions(api, businessId, runId));
};
